// extracted by mini-css-extract-plugin
export var truncate = "_c-0";